import { Module } from '@nestjs/common';
import { PostActivityService } from './post-activity.service';
import { PostActivityController } from './post-activity.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PostActivityEntity } from './post-activity.entity';
import { PostEntity } from '../post/post.entity';
import { PostPointsEntity } from '../post/post-points.entity';
import { PostActivitySharedEntity } from './Post_activityshared.entity';
import { UserPointsEntity } from '../post/user-points.entity';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { UserEntity } from '../user/user.entity';
import { HierarchyEntity } from '../hierarchy/hierarchy.entity';

@Module({
  imports:[
    TypeOrmModule.forFeature([PostActivityEntity,PostEntity,PostPointsEntity,PostActivitySharedEntity,
      UserPointsEntity,NotificationsEntity,UserEntity,HierarchyEntity]),
  ],
  exports: [PostActivityService],
  providers: [PostActivityService],
  controllers: [PostActivityController]
})
export class PostActivityModule {}
